import { cn } from '@Blocks/_components/ui/utils';

import type { SectionDecorationOptions } from '@/_types/Shared/Common';
import type {
	ColmunsElements,
	FooterContentsVariations,
	FooterOptions,
} from '@/_types/Shared/Footer';
import type { MenusType, SiteType } from '@/_types/Shared/SiteDatas';
import Decorations from '@/App/Blocks/_components/Decorations';

import Html from '../Html';
import Contact from './Elements/Contact';
import Logo from './Elements/Logo';
import Menu from './Elements/Menu';
import Socials from './Elements/Socials';
import SubFooter from './Elements/SubFooter';

export default function Footer({
	site,
	menus,
	context,
	minos,
}: {
	site: SiteType;
	menus: MenusType;
	context: FooterOptions;
	minos: SectionDecorationOptions;
}) {
	const columns = context.columns;

	// eslint-disable-next-line no-console
	console.log('made with ♡ by Spade!');

	let colNbr = '';
	if (columns?.length === 4) {
		colNbr = 'tablet:grid-cols-2 desktop:grid-cols-4';
	} else if (columns?.length === 3) {
		colNbr = 'tablet:grid-cols-2 desktop:grid-cols-3';
	} else if (columns?.length === 2) {
		colNbr = 'tablet:grid-cols-2 desktop:grid-cols-2';
	}

	const contentType = {
		custom_logo: <Logo site={site} logo={site.custom_logo} />,
		secondary_logo: <Logo site={site} logo={site.secondary_logo} />,
		contact: (
			<Contact
				address={context.contact?.address}
				phone={context.contact?.phone}
				mail={context.contact?.mail}
			/>
		),
		socials: <Socials socials={context.socials} />,
		footer_menu_a: <Menu menu={menus.footer_menu_a} />,
		footer_menu_b: <Menu menu={menus.footer_menu_b} />,
		html: null,
	};

	return (
		<footer className='minos-grid relative z-[11] bg-minos-footer-bg'>
			<Decorations
				isSectionDecorated={minos?.isSectionDecorated}
				type={minos?.type}
				pathClassName='fill-minos-footer-bg'
				isFooter
			>
				<>
					{columns && columns.length > 0 && (
						<nav
							aria-labelledby='footer-navigation'
							className='col-start-2 col-end-14 py-16 tablet:pb-20 tablet:pt-28'
						>
							<ul className={cn('grid grid-cols-1 gap-8 tablet:gap-14 ', colNbr)}>
								{columns.map((column: ColmunsElements, index: number) => (
									<li key={index} className='col-span-1'>
										{column.title && (
											<h3 className='minos-footer-titre-font text-2xl tablet:minos-footer-titre-font'>
												{column.title}
											</h3>
										)}
										{column.contents && column.contents.length > 0 && (
											<>
												{column.contents.map((content: FooterContentsVariations, i: number) => (
													<div
														className='minos-footer-text-font mt-3 text-base tablet:minos-footer-text-font'
														key={i}
													>
														{content === 'html' && column.html && column.html[i] ? (
															<Html context='footer' html={column.html[i]} />
														) : (
															<>{contentType[content]}</>
														)}
													</div>
												))}
											</>
										)}
									</li>
								))}
							</ul>
						</nav>
					)}
				</>
			</Decorations>
			<SubFooter
				name={context.valueCopyright ? context.valueCopyright : site.name}
				copyrightsMenu={menus.copyrights_menu}
				showCopyrightsSpade={context.displayCopyrightSpade}
			/>
		</footer>
	);
}
